import Vue from 'vue'
import Vuex from 'vuex'

import EngineStore from './engine'
import ScriptsStore from './scripts'
import VocabStore from './vocab'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    theme: 'light',
    loading: false,
  },
  mutations: {
    UPDATE_LOADING(state, loadingState: boolean) {
      state.loading = loadingState
    },
  },
  modules: {
    engine: EngineStore,
    scripts: ScriptsStore,
    vocab: VocabStore,
  },
})
